import {Cohort} from 'common/query-builder/cohorts-query-builder/models/cohort';
import {SerializedCohort} from 'common/query-builder/cohorts-query-builder/models/types/serialized-cohort-types';

export enum CohortsModalError {
  NameRequired,
  ExistingName,
}

export interface CohortsModalState {
  showQueryBuilderSkeleton: boolean;
  name: string;
  showCreateEntityModal: boolean;
  loadingCohorts: boolean;
  loadingCohortCount: boolean;
  cohortCount: number;
  errors: Set<CohortsModalError>;
  cohort: Cohort;
  samplingFactor: number;
  saveCohortAttempted: boolean;
}

export interface InlineCohortsModalProps {
  cohort?: SerializedCohort;
  projectId: number;
  workspaceId?: number;
  dataGroupId?: string;
  canSave?: boolean;
  canEdit?: boolean;
  canApplyUnsavedCohort?: boolean;
  projectHasCohorts?: boolean;
  supportB2bCohorts?: boolean;
  userId?: number;
  showCohortCount?: boolean;
  showDataGroupsSelector?: boolean;
  trackName?: string;
  name?: string;
  open?: boolean;
  onClose?: () => void;
  onChange?: (state: string) => void;
  onTrack?: (eventName: string, props: any) => void;
  onCommitCohort?: (details: {name: string; cohort: Cohort}) => void;
  onCommitSavedCohort?: (details: {id: number; name: string; cohort: Cohort; savedAsNew: boolean}) => void;
}

type CohortStagedValue = {
  name: string;
  cohort: Cohort;
};

type CohortSavedValue = {
  id: number;
  name: string;
  cohort: Cohort;
  savedAsNew: boolean;
};

export type CohortResult = {
  cohortStagedValue: CohortStagedValue | null;
  cohortSavedValue: CohortSavedValue | null;
};

export type CohortResultItem = Omit<CohortSavedValue, `id`> & {
  id?: number;
};
